import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { InvestmentInCompaniesModel } from './investment-incompanies.model';
import { InvestmentInCompaniesService } from './investment-incompanies.service';

@Component({
    selector: 'convfact-investment-incompanies',
    templateUrl: './investment-incompanies.component.html',
    styleUrls: ['./investment-incompanies.component.css'],
    standalone: false
})

export class InvestmentInCompaniesComponent implements OnInit {

  public investmentInCompanies = new InvestmentInCompaniesModel;
  public accounts: AccountingAccountsModel[] = [];

  public spinner: boolean = false;
  public ready: boolean = false;

  constructor(
    private investmentInCompaniesService: InvestmentInCompaniesService,
    private accountingAccountsService: AccountingAccountsService,
    public snackBar: MatSnackBar,
    private router: Router
  ) { }

  public ngOnInit(): void {
    this.accountingAccountsService.getListInvestmentsInCompaniesAccounts()
      .then(data => this.accounts = data);

    const temp = this.router.url.split('/');
    this.spinner = true;
    if (temp.length == 5) {
      const uid = temp[4];
      this.investmentInCompaniesService.get(uid)
        .then(response => {
          this.investmentInCompanies = response;
          this.spinner = false;
          this.ready = true;
        })
    }
    else {
      this.spinner = false;
      this.ready = true;
    }
  }

  public saveData(investmentInCompanies: InvestmentInCompaniesModel): void {
    this.spinner = true;

    if (investmentInCompanies.uid == null) {
      this.investmentInCompaniesService.add(investmentInCompanies)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError(error.error['message']);
        })
    } else {
      this.investmentInCompaniesService.edit(investmentInCompanies)
        .then(response => {
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError("Ha ocurrido un error inesperado al actualizar la inversion")
        })
    }
  }

  public displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public returnToIndex(): void {
    this.router.navigate(['investment/incompanies']);
  }
}
